import { Box, styledComponent, TextField } from '@hermes/web-components'

export const ModalBody = styledComponent(Box)(({ theme }) => ({
  justifySelf: 'center',
  padding: '56px 16px 42px',
  maxWidth: '438px',
  display: 'grid',
  [theme.breakpoints.down('sm')]: {
    padding: '16px'
  },
  '.MuiRating-large': {
    justifySelf: 'center',
    margin: '33px auto',
    label: {
      '.MuiRating-iconEmpty': {
        svg: {
          fill: theme.palette.neutral[300]
        }
      },
      '.MuiRating-iconFilled': {
        svg: {
          fill: '#FFCC14'
        }
      },
      span: {
        svg: {
          width: '40px',
          height: '40px'
        }
      }
    }
  }
}))

export const ReviewTextArea = styledComponent(TextField)({
  '.MuiInputBase-root': {
    height: 'max-content',
    textarea: {
      transition: '0.2s'
    }
  }
})
